export function Logo({ s = 26, onClick }) {
  const h = Math.round(s * 1.5)
  const w = Math.round(h * 0.686) // aspect ratio 867/1265
  return (
    <span
      onClick={onClick}
      style={{ display:'flex', alignItems:'center', gap:10, cursor: onClick ? 'pointer' : 'default' }}
    >
      <picture>
        <source srcSet="/logo.webp" type="image/webp" />
        <img
          src="/logo.png"
          alt="Welland Create — 3D моделирование и подбор оборудования для бассейна, Казахстан"
          width={w}
          height={h}
          style={{ height: h, width:'auto', objectFit:'contain', flexShrink:0 }}
        />
      </picture>
      <span style={{ fontFamily:'var(--font-main)', display:'inline-flex', alignItems:'baseline', gap: Math.round(s * 0.22) }}>
        <span style={{ fontWeight:900, fontSize:s*.62, letterSpacing:'.06em', color:'#FFFFFF' }}>WELLAND</span>
        <span style={{ fontWeight:600, fontSize:s*.43, letterSpacing:'.18em', color:'#0FA3B1' }}>CREATE</span>
      </span>
    </span>
  )
}
